
import React, { Component } from "react";
import App from "../../App";
import "./footer.scss";

import ccdmd_logo from "../../images/logo_ccdmd.svg";
import fleche_top from "../../images/btn_pagetop_arrow.svg";
import clsx from "clsx";
import { IPopupType } from '../../interfaces/ILabyData';

class FooterCCDMD extends Component<any,any> {

  app:App;
  
  constructor(props:any){
    super(props);
    this.app = props.app;
    this.state = {
      version_app:"",
      version_donnees:"",
      intro_active:true,
      game_active:false,
      popup_ouvert:false,
      popupType:""
    };
  }

  componentDidMount(){
      
  }

  
  public setVersionNumber(newVersionAppNumber:string="1.00", newVersionDonneesNumber:string="000"){
    this.setState({version_app:newVersionAppNumber, version_donnees:newVersionDonneesNumber});
  }
  
  public setIntroActive(intro_active:boolean){
    this.setState({intro_active:intro_active});
  }
  public setGameActive(game_active:boolean){
    this.setState({game_active:game_active});
  }
  public setPopupOuvert(popup_ouvert:boolean, popupType:IPopupType=""){
    const newPopupType = popupType;
    this.setState({popup_ouvert:popup_ouvert, popupType:newPopupType});
  }

  public getWrapperClasses(){
    let classes = " ";
    if (this.state.intro_active) classes += " intro_active";
    if (this.state.game_active) classes += " game_active";
    if (this.state.popup_ouvert) classes += " popup_ouvert";
    if (this.state.popupType) classes += " " + this.state.popupType;
    return classes;
  }

  render() { 
    return (
      <div className={clsx("wrapper-footer", this.getWrapperClasses())}>
        <div className="partie-superieure"><a id="lien_accessibilite" target="_blank" href="accessibilite.html">Accessibilité</a><a id="conditions_utilisation" target="_blank" href="conditions-d-utilisation.html">Conditions d'utilisation</a></div>
        <div className="partie-inferieure">
          <div className="copyright">
            <img src={ccdmd_logo} alt="ccdmd" />
            <p>© Centre collégial de développement de matériel didactique, 2022<span className="version"><br />v.{this.state.version_app}-{this.state.version_donnees}</span></p>
          </div>
          <div className="btn-retour-haut-de-page"><button onClick={() => {window.scrollTo(0, 0);}} title="Retour en haut de la page"><img src={fleche_top} alt="Retour en haut de la page" /></button></div>
        </div>       
      </div>
    )
  }
}

export default FooterCCDMD;
